module.exports = __webpack_public_path__ + "img/car-wrench.0705e8f6.svg";